import { type DeviceBuyback, DeviceBuybackStatus, textDeviceBuybackStatus } from '@maru44/huntre-utils/src/models/deviceBuyback'
import { Box, Button, Chip, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material'
import { useContext } from 'react'
import { Link } from 'react-router-dom'
import { AuthContext } from 'src/components/providers/AuthProvider'
import { ClientContext } from 'src/components/providers/ClientProvider'
import { useDeviceBuybacks } from 'src/hooks/deviceBuyback/useDeviceBuybacks'
import { formatTimestamp } from 'src/utils/firebase'
import { BuybackGuide } from './BuybackGuide'

const statusColor = (status: DeviceBuybackStatus) => {
  switch (status) {
    case DeviceBuybackStatus.Paid:
      return 'success'
    case DeviceBuybackStatus.Approved:
    case DeviceBuybackStatus.Received:
    case DeviceBuybackStatus.Assessed:
      return 'info'
    case DeviceBuybackStatus.NeedsFix:
      return 'warning'
    case DeviceBuybackStatus.Rejected:
    case DeviceBuybackStatus.Returned:
    case DeviceBuybackStatus.Expired:
      return 'error'
    case DeviceBuybackStatus.Applied:
    case DeviceBuybackStatus.Canceled:
      return 'default'
  }
}

export const DeviceBuybacksPage = () => {
  const [user] = useContext(AuthContext)
  const { client } = useContext(ClientContext)
  const { listDeviceBuybacks } = useDeviceBuybacks(client?.id, user?.uid)

  return (
    <Box>
      <Stack spacing={2}>
        <Stack direction="row" sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h5">デバイスの買取</Typography>
          <Button component={Link} to={`/clients/${client?.id}/buybacks/new`} variant="contained">
            買取に出す
          </Button>
        </Stack>

        {/* 初めて来た人の着地点なので、説明はたたまず常に出す */}
        <BuybackGuide />

        <Typography variant="h6">お申し込みの履歴</Typography>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>申請日</TableCell>
                <TableCell>デバイス</TableCell>
                <TableCell>状態</TableCell>
                <TableCell align="right">買取金額</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {listDeviceBuybacks.data?.map((v: DeviceBuyback) => (
                <TableRow key={v.id} hover component={Link} to={`/clients/${client?.id}/buybacks/${v.id}`} sx={{ textDecoration: 'none' }}>
                  <TableCell>{v.createdAt && formatTimestamp(v.createdAt)}</TableCell>
                  <TableCell>{v.deviceIds?.length === 1 ? v.deviceIds[0] : `${v.deviceIds?.length ?? 0} 台`}</TableCell>
                  <TableCell>
                    <Chip size="small" color={statusColor(v.status)} label={textDeviceBuybackStatus(v.status)} />
                  </TableCell>
                  <TableCell align="right">{v.totalPrice == null ? '-' : `${v.totalPrice.toLocaleString()} 円`}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            component="div"
            count={listDeviceBuybacks.totalCount}
            page={listDeviceBuybacks.page}
            rowsPerPage={listDeviceBuybacks.pageSize}
            rowsPerPageOptions={[listDeviceBuybacks.pageSize]}
            onPageChange={(_, page) => listDeviceBuybacks.goToPage(page)}
          />
        </TableContainer>
      </Stack>
    </Box>
  )
}
